import BaseService from '../../core/service/BaseService';
import OrgaoIntegracaoService from './OrgaoIntegracaoService';

const url = 'contas-acessos';

class ContaAcessoIntegracaoService extends BaseService {
    async getMe(login) {
        const res = await window.$http.get(`${url}/permissoes/${login}`);
        const orgaoUsuarioLogado = await OrgaoIntegracaoService.getOrgaoUsuarioLogado();
        return { ...res.data, orgaoUsuarioLogado };
    }
}

export default new ContaAcessoIntegracaoService(url);
